import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
    loadAttendanceDetails,
    loadServiceDetailsForContractId
} from '../../../store/directusService';
import DateSelect from '../../formElements/DateSelect';
import MultiSelect from '../../formElements/MultiSelect';
import SingleSelect from '../../formElements/SingleSelect';

import form from '../../../commonStyles/formStyles.module.css';

const ModalContentAttendanceOutcome = ({ contracts = [], errors, selects, onChange }) => {
    // HOOKS
    const dispatch = useDispatch();

    // STORE STATE
    const serviceDetailsForContractId = useSelector(
        (state) => state.entities.directusService.serviceDetailsForContractId
    );
    const attendanceStatuses = useSelector(
        (state) => state.entities.directusService.attendanceDetails
    );

    // USE EFFECTS
    useEffect(() => {
        if (attendanceStatuses?.length < 1) dispatch(loadAttendanceDetails());
    }, []);

    useEffect(() => {
        onChange('service', {});
    }, [serviceDetailsForContractId]);

    useEffect(() => {
        selects.contract?.id && dispatch(loadServiceDetailsForContractId(selects.contract.id));
    }, [selects.contract]);

    // RENDER
    return (
        <div className={form.formSection}>
            <div className={form.formColumn}>
                <MultiSelect
                    id="attendanceStatuses"
                    label="Attendance Statuses"
                    placeholder="Select attendance statuses..."
                    mandatory={true}
                    customClass="absolutePosition"
                    menuItems={attendanceStatuses || []}
                    preSelectedIds={(selects.attendanceStatuses || []).map((el) => el.id)}
                    preSelects={selects.attendanceStatuses || []}
                    error={errors.attendanceStatuses}
                    onChange={(ids) =>
                        onChange(
                            'attendanceStatuses',
                            attendanceStatuses?.filter((el) => ids.includes(el.id))
                        )
                    }
                />
                <DateSelect
                    id="date"
                    label={'Date Range'}
                    value={selects.date}
                    isDefault={true}
                    mandatory={true}
                    error={errors.date}
                    onDateChange={(date) => onChange('date', date)}
                />
            </div>
            <div className={form.formColumn}>
                <SingleSelect
                    id="contract"
                    label="Contract"
                    placeholder="Select contract..."
                    mandatory={true}
                    customClass="absoluteAndHeightControlSecondLevel"
                    menuItems={contracts}
                    selectedId={selects.contract?.id || ''}
                    selected={
                        (selects.contract?.id &&
                            contracts.find((el) => el.id === selects.contract.id)) ||
                        {}
                    }
                    error={errors.contract}
                    onChange={(id) =>
                        onChange(
                            'contract',
                            contracts.find((el) => el.id === id)
                        )
                    }
                />
                <SingleSelect
                    id="service"
                    label="Service"
                    placeholder="Select service..."
                    mandatory={true}
                    disabled={serviceDetailsForContractId.length === 0 || !selects.contract?.id}
                    customClass="absoluteAndHeightControl"
                    menuItems={serviceDetailsForContractId || []}
                    selectedId={selects.service?.id || ''}
                    selected={
                        (selects.service?.id &&
                            serviceDetailsForContractId.find(
                                (el) => el.id === selects.service.id
                            )) ||
                        {}
                    }
                    error={errors.service}
                    onChange={(id) =>
                        onChange(
                            'service',
                            serviceDetailsForContractId.find((el) => el.id === id)
                        )
                    }
                />
            </div>
        </div>
    );
};

ModalContentAttendanceOutcome.propTypes = {
    contracts: PropTypes.arrayOf(PropTypes.object),
    errors: PropTypes.object,
    selects: PropTypes.object,
    onChange: PropTypes.func
};

export default ModalContentAttendanceOutcome;
